export default __webpack_public_path__ + "static/media/logo.ac41d395.svg";